
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging",
      function () {
        return require("private-next-pages/evcharging/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging"])
      });
    }
  